/**
 * Phase 261c — PWA install funnel telemetry.
 *
 * Thin wrapper around `window.posthog.capture` that never throws and
 * silently no-ops when PostHog isn't initialized (preview pods without
 * REACT_APP_POSTHOG_KEY, private-mode browsers, etc.).
 *
 * Funnel events emitted by the PWA surfaces:
 *   pwa_banner_shown          — banner cleared all visibility gates
 *   pwa_banner_dismissed      — user clicked X to close the banner
 *   pwa_install_prompted      — promptInstall() invoked (banner or card)
 *   pwa_install_accepted      — native prompt → outcome === 'accepted'
 *   pwa_install_rejected      — native prompt → outcome === 'dismissed'
 *   pwa_app_installed         — browser fired the `appinstalled` event
 *                               (catches the install REGARDLESS of source —
 *                                URL-bar icon, banner, card, OS-level)
 *   pwa_card_viewed           — Profile install card rendered
 *   pwa_card_cooldown_cleared — user clicked "Show banner again"
 *
 * Standard properties on every event:
 *   persona  : 'desktop' | 'mobile'
 *   role     : user.role  (academy_owner | coach | employee | student | …)
 *   source   : 'banner' | 'profile_card' | 'native'
 *
 * Extra properties per event documented inline at the call site.
 */

const DESKTOP_PERSONAS = new Set(['academy_owner', 'coach', 'employee', 'super_admin']);

export function personaForRole(role) {
  return DESKTOP_PERSONAS.has(role) ? 'desktop' : 'mobile';
}

export function trackPwa(event, props = {}) {
  try {
    if (typeof window === 'undefined') return;
    const ph = window.posthog;
    if (!ph || typeof ph.capture !== 'function') return;
    ph.capture(event, props);
  } catch (_) {
    /* analytics is best-effort */
  }
}
